(() => {
  if (window.rawBlendedNewsletterLoaded) return;
  window.rawBlendedNewsletterLoaded = true;
  const key = 'rb_newsletter_v1';
  const maxAge = 30 * 60 * 1000;
  const channels = ['instagram_story', 'instagram_bio', 'instagram_unspecified', 'whatsapp', 'other_utm', 'other_referral', 'direct_unknown'];
  const params = new URLSearchParams(window.location.search);
  const isTest = params.get('rb_test') === '1' || params.has('preview_theme_id') || Boolean(window.Shopify?.designMode) || window.location.hostname.endsWith('.shopifypreview.com');
  const hasUtm = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].some(k => params.has(k));
  const source = (params.get('utm_source') || '').toLowerCase();
  const content = (params.get('utm_content') || '').toLowerCase();
  const campaign = (params.get('utm_campaign') || '').toLowerCase();
  function channelFromUrl() {
    if (hasUtm) {
      if (campaign !== 'reveal_001') return 'other_utm';
      if (source === 'instagram') return content === 'story' ? 'instagram_story' : content === 'bio' ? 'instagram_bio' : 'instagram_unspecified';
      if (source === 'whatsapp') return 'whatsapp';
      return 'other_utm';
    }
    try {
      const host = new URL(document.referrer).hostname;
      if (host === 'instagram.com' || host.endsWith('.instagram.com')) return 'instagram_unspecified';
      if (host !== window.location.hostname && host !== 'rawblended.com' && host !== 'www.rawblended.com' && host !== 'qnedrt-2v.myshopify.com') return 'other_referral';
    } catch {}
    return 'direct_unknown';
  }
  const currentChannel = channelFromUrl();
  let memory = null;
  const bound = new WeakSet();
  function allowed() {
    if (document.getElementById('rb-age-content')?.hidden) return false;
    const privacy = window.Shopify?.customerPrivacy;
    try {
      const consent = privacy?.currentVisitorConsent();
      return consent?.analytics === 'yes' && consent?.marketing === 'yes' && privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true;
    } catch { return false; }
  }
  function clear() {
    memory = null;
    try { window.sessionStorage.removeItem(key); } catch {}
  }
  function read() {
    if (memory && Date.now() - memory.time < maxAge) return memory;
    try {
      const data = JSON.parse(window.sessionStorage.getItem(key));
      if (data && channels.includes(data.channel) && Number.isFinite(data.time) && Date.now() >= data.time && Date.now() - data.time < maxAge) return data;
    } catch {}
    return null;
  }
  function write(data) {
    memory = data;
    try { window.sessionStorage.setItem(key, JSON.stringify(data)); } catch {}
  }
  function attribution() {
    if (!allowed()) return null;
    let data = read();
    if (!data || (hasUtm && data.page !== currentChannel)) {
      data = {channel: currentChannel, time: Date.now(), test: isTest, pending: false, page: currentChannel};
      write(data);
    }
    if (isTest && !data.test) { data.test = true; write(data); }
    return data;
  }
  function tags(data) {
    const result = ['newsletter', 'rb_reveal_001', data ? 'rb_source_' + data.channel : 'rb_source_unattributed'];
    if (isTest || data?.test) result.push('rb_test');
    return result.join(',');
  }
  function update() {
    const permitted = allowed();
    if (!permitted) clear();
    const data = permitted ? attribution() : null;
    document.querySelectorAll('[data-rb-newsletter]').forEach(root => {
      const form = root.querySelector('form');
      const input = root.querySelector('[data-rb-source-tags]');
      const preferences = root.querySelector('[data-rb-privacy-settings]');
      if (preferences && typeof window.privacyBanner?.showPreferences === 'function') {
        preferences.hidden = false;
        if (!bound.has(preferences)) {
          bound.add(preferences);
          preferences.addEventListener('click', () => window.privacyBanner.showPreferences().catch(() => {}));
        }
      }
      if (input) input.value = tags(data);
      if (form && !bound.has(form)) {
        bound.add(form);
        form.addEventListener('submit', () => {
          const latest = attribution();
          if (input) input.value = tags(latest);
          if (latest) {
            latest.pending = true;
            latest.time = Date.now();
            write(latest);
          }
        });
      }
    });
    if (!permitted || typeof window.clarity !== 'function' || !data) return;
    window.clarity('set', 'rb_channel', data.channel);
    window.clarity('set', 'rb_campaign', 'reveal_001');
    window.clarity('set', 'rb_test', data.test || isTest ? 'yes' : 'no');
    if (data.pending && document.querySelector('[data-rb-newsletter-accepted]')) {
      data.pending = false;
      write(data);
      window.clarity('event', 'rb_newsletter_form_accepted');
    }
  }
  document.addEventListener('visitorConsentCollected', update);
  document.addEventListener('rb:clarity-ready', update);
  document.addEventListener('rb:age-accepted', update);
  document.addEventListener('shopify:section:load', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, {once: true});
  else update();
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) update(); });
  }
  let attempts = 0;
  const timer = window.setInterval(() => {
    update();
    attempts += 1;
    if (attempts >= 20) window.clearInterval(timer);
  }, 500);
})();



(() => {
  function showNextStep() {
    const next = document.querySelector('[data-rb-newsletter-accepted]');
    if (!next || next.dataset.rbFocused === 'true') return;
    if (document.querySelector('#rb-age-gate[open]')) return;
    next.dataset.rbFocused = 'true';
    next.focus({preventScroll:true});
    next.scrollIntoView({block:'center',behavior:'instant'});
  }
  document.addEventListener('rb:age-accepted', () => window.setTimeout(showNextStep, 800));
  document.addEventListener('shopify:section:load', showNextStep);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showNextStep, {once:true});
  else showNextStep();
})();
